<template>
  <ScrollContainer
    ref="scrollContainerRef"
    class="AccountsPage"
    viewport="Mobile"
    includeViewportPadding="bottom"
  >
    <SyncIndicator
      v-if="accounts.length > 0"
      itemName="accounts"
      :isSyncing="isSyncingAccounts"
      :lastUpdatedDate="accountsSyncDate"
      v-bind="{scrollElementRef}"
    />

    <EmailVerificationReminderView />

    <FinancialAccountsView />
  </ScrollContainer>

  <Teleport :to="PortalId.Body">
    <Transition>
      <AccountSheetModalView
        v-if="accountModalRoute"
        :accountId="accountModalRoute.params.id.toString()"
      />
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import ScrollContainer from "@cosine/components/ScrollContainer.vue";
import useModalRoute from "@cosine/composables/useModalRoute";
import { RouteName } from "@cosine/routes";
import AccountSheetModalView from "@cosine/views/AccountSheetModalView.vue";
import FinancialAccountsView from "@cosine/views/FinancialAccountsView.vue";
import { PortalId } from "@cosine/components/Portal.types";
import useFinancialStore from "@cosine/stores/useFinancialStore";
import { storeToRefs } from "pinia";
import SyncIndicator from "@cosine/components/SyncIndicator.vue";
import { computed, useTemplateRef } from "vue";
import EmailVerificationReminderView from "@cosine/views/EmailVerificationReminderView.vue";
import useFullSeoMeta from "@cosine/composables/useFullSeoMeta";

const scrollContainerRef = useTemplateRef("scrollContainerRef");

useFullSeoMeta({
  title: "Accounts",
});

const {
  modalRoute: accountModalRoute,
} = useModalRoute(RouteName.accountsView);

const financialStore = useFinancialStore();
const {
  accounts,
  isSyncingAccounts,
  accountsSyncDate,
} = storeToRefs(financialStore);

const scrollElementRef = computed(() => scrollContainerRef.value?.trackEl);
</script>

<style lang="scss" scoped>
.AccountsPage {
  position: relative;
  isolation: isolate;

  height: 100%;

  background-color: var(--themeColorBackgroundSurface);
}
</style>
